import React from 'react';
import PropTypes from 'prop-types';
import SelectField from '../SelectField';

const CtaOptions = [
  '瞭解詳情',
  '來去逛逛',
];

export default function CtaField({
  value,
  onChange,
  disabled,
  required,
}) {
  return (
    <SelectField
      style={{ width: '50%' }}
      title="行動呼籲選項"
      value={value}
      options={CtaOptions}
      onChange={onChange}
      disabled={disabled}
      required={required}
    />
  );
}

CtaField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

CtaField.defaultProps = {
  value: '',
  onChange: () => {},
  disabled: false,
  required: true,
};
